import { render, staticRenderFns } from "./EcCom.vue?vue&type=template&id=07fa8815"
import script from "./EcCom.vue?vue&type=script&lang=js"
export * from "./EcCom.vue?vue&type=script&lang=js"
import style0 from "./EcCom.vue?vue&type=style&index=0&id=07fa8815&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports